<!-- <div class="p-wrapper-custom pagination-order py-3 pagination-right-single">
  <div
    class="samplepo-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <h2>Open orders by In Hands Date</h2>
    <div class="samplepo-panel col-auto d-flex justify-content-between">
      <span class="d-flex gap-2 customizefilter-btn">
        <p-button
          label="Export Excel"
          variant="outlined"
          icon="pi pi-cloud-upload"
          severity="secondary"
          (click)="exportQuadReport4()"
          class="fullwdth secondary-btn" />

        <span class="cross-border" (click)="onClose()"
          ><i class="pi pi-times"></i
        ></span>
      </span>
    </div>
  </div> -->

<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center m-3 mt-0 mt-2">
        <span class="col-auto">
          <h2 class="mb-0">Open orders by In Hands Date</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn align-items-center">
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportQuadReport4()"
            class="fullwdth secondary-btn" />

          <span class="cross-border" (click)="onClose()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>

      <p-table
        #dt
        stripedRows
        [rows]="25"
        [showCurrentPageReport]="true"
        [scrollable]="true"
        scrollHeight="calc(100vh - 310px)"
        [size]="'small'"
        [resizableColumns]="true"
        [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]"
        [paginator]="true"
        paginatorStyleClass="paginator-table"
        [value]="filterQr4List"
        styleClass="p-datatable-customers"
        [rowHover]="true"
        [rows]="20"
        [showCurrentPageReport]="true"
        [paginator]="filterQr4List.length >= 20"
        [autoLayout]="true"
        [resizableColumns]="true"
        styleClass="table-listing">
        <ng-template pTemplate="header">
          <tr class="table-head">
            <th class="text-center">In Hands Date</th>
            <th class="text-center">Order #</th>
            <th class="text-center">Client</th>
            <th class="text-center">Job Name</th>
            <th class="text-center">% Cost In</th>
            <th class="text-center">Pre-Bill/Inv</th>
            <th class="text-center">Split</th>
            <th class="text-center">Total Merch</th>
          </tr>
          <tr>
            <th>
              <jni-date-filter
                [dataList]="qr4List"
                [columnName]="inHandsDateColumn"
                (emitCancelFilter)="clearFilter($event)"
                (emitApplyFilter)="applyFilter($event)">
              </jni-date-filter>
            </th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="orderNumber"
                  id="orderNumber"
                  style="max-width: 200px"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'orderNumber',
                      'startsWith'
                    )
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="clientName"
                  id="clientName"
                  style="max-width: 200px"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'clientName',
                      'startsWith'
                    )
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="jobName"
                  id="jobName"
                  style="max-width: 200px"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'jobName',
                      'startsWith'
                    )
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="costIn"
                  id="costIn"
                  style="max-width: 200px"
                  (input)="
                    dt.filter($any($event.target).value, 'costIn', 'startsWith')
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="preBillInv"
                  id="preBillInv"
                  style="max-width: 200px"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'preBillInv',
                      'startsWith'
                    )
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="split"
                  id="split"
                  style="max-width: 200px"
                  (input)="
                    dt.filter($any($event.target).value, 'split', 'startsWith')
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="totalMerch"
                  id="totalMerch"
                  style="max-width: 200px"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'totalMerch',
                      'startsWith'
                    )
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-qr4List let-rowIndex="rowIndex">
          <tr>
            <td>{{ qr4List.inHandsDate | date: "MM-dd-yyyy" }}</td>
            <td>
              <a
                class="link"
                (click)="redirectToSummary(qr4List.orderNumber)"
                >{{ qr4List.orderNumber }}</a
              >
            </td>
            <td>
              <a
                class="link"
                (click)="redirectToClientSummary(qr4List.clientId)"
                >{{ qr4List.clientName }}</a
              >
            </td>
            <td>{{ qr4List.jobName }}</td>
            <td class="align-right">
              <a
                class="link"
                (click)="
                  redirectToSamplePO(
                    qr4List.orderNumber,
                    qr4List.purchaseOrderNumber
                  )
                ">
                {{ qr4List.costIn | number: "1.2-2" }}
              </a>
            </td>
            <td class="align-right">
              {{ qr4List.preBillInv | number: "1.2-2" }}
            </td>
            <td class="align-right">
              {{ qr4List.split | number: "1.2-2" }}
            </td>
            <td class="align-right">
              {{ qr4List.totalMerch | number: "1.2-2" }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="30">No Data Found.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [isModal]="true"
      [clientIdFromModal]="clientId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeEvent)="closeModalForClient()">
    </jni-client-details>
  </div>
</jni-modal-stacker>

<!-- TO DO: Need to add component that are not yet added in project migration-->
<jni-modal-stacker
  *ngIf="samplePODisplayModal"
  [displayModal]="samplePODisplayModal"
  (closeEvent)="closeModalForSamplePO()">
  <h1 class="panelHeading">SamplePO Listing</h1>
  <div class="panelBody">
    <jni-samplepo-listing
      [ponumber]="ponumber"
      (scrollHiddenStatus)="addScollHiddenClass()">
    </jni-samplepo-listing>
  </div>
</jni-modal-stacker>
